import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { parseISO } from "date-fns/parseISO";
import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays";
import { useFormatter, useTranslations } from "next-intl";
var important = function(content) {
    return /*#__PURE__*/ _jsx("b", {
        suppressHydrationWarning: true,
        children: content
    });
};
var timeFormatOptions = {
    hour: "numeric",
    minute: "numeric"
};
var dateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "medium"
};
var useRelativeDate = function(date) {
    var format = useFormatter();
    var t = useTranslations("shared.stringsLegacy.dates");
    var translationsMap = useMemo(function() {
        var dateValue = parseISO(date);
        return {
            dateToday: t.rich("dateToday", {
                important: important,
                date: format.dateTime(dateValue, timeFormatOptions)
            }),
            dateYesterday: t.rich("dateYesterday", {
                important: important,
                date: format.dateTime(dateValue, timeFormatOptions)
            }),
            dateLabel: t.rich("dateLabel", {
                important: important,
                date: format.dateTime(dateValue, dateTimeFormatOptions)
            })
        };
    }, [
        date,
        format,
        t
    ]);
    var ref = useState(translationsMap.dateLabel), dateLabel = ref[0], setDateLabel = ref[1];
    // Do not render relative dates in SSR to avoid hydration errors
    useEffect(function() {
        var daysDifference = differenceInCalendarDays(parseISO(date), new Date());
        if (daysDifference === 0) {
            setDateLabel(translationsMap.dateToday);
        }
        if (daysDifference === -1) {
            setDateLabel(translationsMap.dateYesterday);
        }
    }, [
        date,
        translationsMap
    ]);
    return dateLabel;
};
export { useRelativeDate };
